import React, { useEffect } from 'react';
import ReportFilterSelect from './ReportFilterSelect';
import ReportFilterInput from './ReportFilterString';

export type ReportFilterModel = {
  name: string;
  label: string;
  type: string;
  min: string | Date | undefined;
  max: string | Date | undefined;
  options: Array<{ value: any; label: any }> | undefined;
  // [x: string]: string;
};

type ReportFilterProps = {
  filter: ReportFilterModel;
  errorMessage: string;
  onChange: (option: string | undefined) => void;
};

export default function ReportFilter({
  filter: { name, label, type, min, max, options },
  errorMessage,
  onChange,
}: ReportFilterProps) {
  const cases: { [key: string]: React.ReactNode } = {
    date: (
      <input
        type='date'
        className='form-control'
        id={name}
        name={name}
        aria-describedby={name}
        onChange={(e) => onChange(e.target.value)}
      />
    ),
    select: (
      <ReportFilterSelect
        name={name}
        options={options || []}
        onChange={onChange}
      />
    ),
    string: <ReportFilterInput type='text' name={name} onChange={onChange} />,
  };

  return (
    <>
      <label htmlFor={name} className='form-label'>
        {label}
      </label>
      {cases[type] || <div>Erro!</div>}
      {errorMessage && (
        <div className='form-text text-danger'>{errorMessage}</div>
      )}
    </>
  );
}
